import { render, staticRenderFns } from "./AppointmentClipboardList.vue?vue&type=template&id=e7b73970&scoped=true&"
import script from "./AppointmentClipboardList.vue?vue&type=script&lang=js&"
export * from "./AppointmentClipboardList.vue?vue&type=script&lang=js&"
import style0 from "./AppointmentClipboardList.vue?vue&type=style&index=0&id=e7b73970&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7b73970",
  null
  
)

export default component.exports